<template>
  <div>
    <!-- <span
      :class="
        isLoading
          ? 'text-light pull-right mt-1 mr-1'
          : 'text-light pull-right mt-1 mr-1 d-none'
      "
    >
      <i class="fas fa-spinner fa-spin"></i>
    </span> -->
    <select
      v-model="year"
      class="form-control bg-transparent text-light pull-right col-md-1 mr-3"
      id="yearFilter"
    >
      <option value="" selected disabled>Pilih tahun</option>
      <option :value="y.year" v-for="(y, i) in yearLists" :key="i">
        {{ y }}
      </option>
    </select>
    <canvas id="bigChart" height="280px"> </canvas>
  </div>
</template>

<script>
import axios from "axios";
import Chart from "chart.js";
import $ from "jquery";
export default {
  data() {
    return {
      year: "",
      resPenjualan: [],
      isLoading: false,
      // yearList: [{ year: "2019" }, { year: "2020" }, { year: "2021" }],
    };
  },
  computed: {
    yearLists() {
      var max = new Date().getFullYear();
      var min = 2019;
      var years = [];

      for (var i = max; i >= min; i--) {
        years.push(i);
      }
      return years.reverse();
    },
  },
  created() {
    this.bigChart();
    // console.log(this.yearLists);
  },
  methods: {
    bigChart() {
      let dashboardUrl = `seller/dashboard?year=${this.year}`;
      axios
        .get(dashboardUrl)
        .then((response) => {
          return response.data.data.chartStatistic;
        })
        .then((data) => {
          this.resPenjualan = data.bigChart;
          const month = data.bigChartMonth;

          let ctx = document.getElementById("bigChart").getContext("2d");

          var width = window.innerWidth || document.body.clientWidth;
          let gradientStroke = ctx.createLinearGradient(0, 0, width, 0);

          let chartColor = "#FFFFFF";

          gradientStroke.addColorStop(1, "#26e4ebe3");

          let gradientFill = ctx.createLinearGradient(0, 170, 0, 50);
          gradientFill.addColorStop(0, "transparent");
          gradientFill.addColorStop(1, "rgba(59, 227, 249, 0.267)");

          let chart = new Chart(ctx, {
            type: "line",
            data: {
              labels: month,
              datasets: [
                {
                  label: "Jumlah Penjualan",
                  lineTension: 0.1,
                  borderColor: gradientStroke,
                  pointBorderColor: chartColor,
                  pointBackgroundColor: "#1e3d60",
                  pointHoverBackgroundColor: "#1e3d60",
                  pointHoverBorderColor: chartColor,
                  pointBorderWidth: 1,
                  pointHoverRadius: 1,
                  pointHoverBorderWidth: 0,
                  pointRadius: 0,
                  fill: true,
                  backgroundColor: gradientFill,
                  borderWidth: 2,
                  data: this.resPenjualan,
                },
              ],
            },
            options: {
              layout: {
                padding: {
                  left: 20,
                  right: 0,
                  top: 0,
                  bottom: 0,
                },
              },
              maintainAspectRatio: false,
              tooltips: {
                backgroundColor: "#fff",
                titleFontColor: "#333",
                bodyFontColor: "#666",
                bodySpacing: 4,
                xPadding: 12,
                mode: "nearest",
                intersect: 0,
                position: "nearest",
              },
              legend: {
                position: "bottom",
                fillStyle: "#FFF",
                display: false,
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      fontColor: "rgba(255,255,255,0.4)",
                      fontStyle: "bold",
                      beginAtZero: true,
                      maxTicksLimit: 0,
                      padding: 10,
                    },
                    gridLines: {
                      drawTicks: true,
                      drawBorder: false,
                      display: true,
                      color: "rgba(255,255,255,0.1)",
                      zeroLineColor: "transparent",
                    },
                  },
                ],
                xAxes: [
                  {
                    gridLines: {
                      zeroLineColor: "transparent",
                      display: false,
                    },
                    ticks: {
                      padding: 10,
                      fontColor: "rgba(255,255,255,0.4)",
                      fontStyle: "bold",
                    },
                  },
                ],
              },
            },
          });

          let gThis = this;

          $("#yearFilter").on("change", function () {
            gThis.isLoading = true;
            let val = $("#yearFilter").find(":selected").text();
            let dashboardUrl = `seller/dashboard?year=${val}`;
            axios
              .get(dashboardUrl)
              .then((res) => {
                gThis.isLoading = false;
                return res.data.data.chartStatistic;
              })
              .then((data) => {
                gThis.resPenjualan = data.bigChart;
                chart.data.datasets[0].data = data.bigChart;
                chart.update();
              });
          });
        });
    },
  },
};
</script>